import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from '../NavDrawer.styled';
import { RouteConfig } from 'react-router-config';
import Item from './Item';
import PrivacyStatementIcon from '@mui/icons-material/PrivacyTipOutlined';

type PrivacyStatementButtonProps = {
  onClick: (buttonName: string) => void;
  route?: RouteConfig;
};

const PrivacyStatementButton: FC<PrivacyStatementButtonProps> = ({ onClick, route }) => {
  const { t } = useTranslation();

  const openRoute = () => {
    onClick(route?.name);
  };

  if (!route) {
    return null;
  }

  return (
    <NavLink to={route.path as string} key={route.name}>
      <Item
        icon={<PrivacyStatementIcon fontSize="inherit" />}
        menuName={t(`general.header.menu.${route.name}`)}
        handleClick={openRoute}
      />
    </NavLink>
  );
};
export default PrivacyStatementButton;
